import _ from "lodash";
import moment from "moment";
import {
  Component,
  Fragment,
} from "react";
import {
  Link,
} from "react-router-dom";
import {
  withLocation,
} from "CommonCore/router-util";
import store from "CommonState/store";
import antragApi, {
  antragBearbeitbar,
  antragParams,
  schema,
} from "Apis/antrag-api";
import uiconfig from "CommonState/uiconfig";
import {
  popAndReplaceComponent,
} from "CommonCore/location-util";
import {
  dateRange,
  formatNumber,
  LocaleMoneyFormat,
  formatDate,
  LocaleDateFormat,
} from "CommonCore/l10n";
import {
  createInjectsSelector,
  injectsFromSchemaAndRenderMethods,
  patchFields,
} from "CommonCore/schema-util";
import {
  Button,
  Col,
  Container,
  Row,
  Table,
} from "react-bootstrap";
import {
  Awesome,
  EditPanel,
  Panel,
  Pill,
  Spinner,
  Well,
} from "CommonComponents/bricks";
import {
  ellipsis,
} from "CommonCore/util";
import {
  ANTRAGSTATUS,
  ANTRAGSTELLERMODUS,
  getModusFromAntrag,
  antragtypBeginnVerschiebbar,
  istArtTarifvertrag,
  istTypWerkvertrag,
  ROLLEN,
  userPersonalrat,
  userPersonalratTuv,
  userPersonalratWiss,
  userSachb,
  VERTRAGSARTEN,
  VERTRAGSARTEN_LEHRAUFTRAG,
  VERTRAGSARTEN_TARIF,
  VERTRAGSARTEN_VORTRAG,
} from "App/constants";
import {
  formatKonto,
  formatWochentage,
  renderKurzfristinfo,
} from "Apis/massnahme-api";
import DokumentWidget from "App/components/dokument-widget";
import FinanzierungQVBHinweis from "App/mn-finanzierung-qvb-hinweis";
import AntragDruckenPopup from "App/antrag-drucken-popup";
import TR from "Common/translate";
import {
  togglePlugin,
} from "App/plugins";

const injects = [
  ...injectsFromSchemaAndRenderMethods(schema),
];

const selectInjects = createInjectsSelector(injects);

@uiconfig
@withLocation
@antragApi.current
@antragApi.uiList(antragParams())
@store(
  "user",
  "k_nutzerLookup",
  "nutzersbLookup",
  "k_antragstatusLookup",
  "k_einrichtungLookup",
  "k_vertragsartLookup",
  "k_nutzerLookup",
  "k_taetigkeitLookup",
  "k_antragstypLookup",
  "k_qualizielLookup",
  "k_vertragsgrundLookup",
  "flag_antragstellermodus",
  "k_amtsdienstbezLookup",
  "k_deputatminderungLookup",
  "k_ohneaus_grundLookup",
  "k_tarifbefristetLookup",
)
export default class AntragInfoWidget extends Component {
  // Antragszusammenfassung anzeigen

  constructor() {
    super();
    this.state = { werte: {}, editsAntrag: {}, expandTätigkeiten: {} };
  }

  getEntity = () => {
    const { currentAntrag } = _.cloneDeep(this.props);
    _.assign(currentAntrag, this.state.editsAntrag);
    return currentAntrag;
  };

  onChangeAntrag = change => {
    const { editsAntrag } = this.state;
    _.assign(editsAntrag, change);
    this.setState({ editsAntrag: editsAntrag });
  };

  onCloseAntrag = () => {
    this.setState({ editsAntrag: {} });
  };

  saveAntrag = async() => {
    const {
      saveAntrag,
    } = this.props;
    const copy = _.cloneDeep(this.getEntity());
    await saveAntrag(copy);
    this.onChangeAntrag(copy);
  };

  render() {
    const { user, k_einrichtungLookup,
            k_taetigkeitLookup,
            k_qualizielLookup,
            k_vertragsgrundLookup,
            flag_antragstellermodus,
            k_amtsdienstbezLookup,
            k_deputatminderungLookup,
            k_ohneaus_grundLookup,
            k_tarifbefristetLookup } = this.props;

    const { popupAntragDrucken, expandTätigkeiten } = this.state;

    const wait = Object.keys(this.props).find(p => p.endsWith("Inflight")) || !k_taetigkeitLookup;

    const antrag = this.getEntity();
    if (!antrag || wait) {
      return <Spinner />;
    }
    const istSachb = user ? userSachb(user) : false;
    const istPR = user ? userPersonalrat(user) : false;
    const istPRTuv = user ? userPersonalratTuv(user) : false;
    const istPRWiss = user ? userPersonalratWiss(user) : false;
    const istAst = user ? user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER : false;
    const istDekan = user ? user.ro_id == ROLLEN.ROLLE_DEKANAT : false;
    const istWerkvertrag = istTypWerkvertrag(antrag.a_katid);
    const istLehrauftrag = antrag.a_artid == VERTRAGSARTEN_LEHRAUFTRAG;
    const istTarif = antrag && istArtTarifvertrag(antrag.a_artid);
    const istVortrag = VERTRAGSARTEN_VORTRAG.indexOf(antrag.a_artid) >= 0;
    const istGSB = user ? user.ro_id == ROLLEN.ROLLE_GLEICHSTELLUNG : false;
    const istSBV = user ? user.ro_id == ROLLEN.ROLLE_SBV : false;
    const istAussenwirtschaft = user ? user.ro_id == ROLLEN.ROLLE_AUSSENWIRTSCHAFT : false;
    const istAdmin = user ? user.ro_id == ROLLEN.ROLLE_ADMIN : false;
    const istProf = user ? user.ro_id == ROLLEN.ROLLE_PROFESSOR : false;
    const modusKey = flag_antragstellermodus || getModusFromAntrag(antrag);
    const modus = ANTRAGSTELLERMODUS[modusKey] || {};

    const MAX_TAET_BEZ = 200;

    // Argumente für Pluginschaltung
    const args = {
      istLehrauftrag,
      istWerkvertrag,
      istTarif,
      istWiss: antrag.atd_ist_wiss,
      istWHK: antrag.a_artid == VERTRAGSARTEN.WHK,
    };

    // PDF nur bei Anträgen mit Eingangsdatum anbieten
    let pdfContent;
    let pdfContent2;
    let pdfContent3;
    if (!istWerkvertrag && !istProf) {
      if (!istAst) {
        // Uni darf den Antrag hier herunterladen
        pdfContent = antrag.a_eingangsdat && !istSBV && !istGSB && (!istAussenwirtschaft || istAdmin) ? <Button variant='outline-primary' onClick={this.onAntragformular}>Antrags-PDF herunterladen</Button> : null;
        if (!istLehrauftrag) {
          pdfContent2 = antrag.a_eingangsdat && !istTarif && !istSBV && !istGSB && !istPRWiss && !istVortrag ? <Button variant='outline-primary' onClick={this.onEmpfangsbescheinigung}>Empfangsbescheinigung-PDF herunterladen</Button> : null;
        } else {
          pdfContent2 = antrag.a_eingangsdat && <Button variant='outline-primary' onClick={this.onBeauftragung}>Beauftragungs-PDF herunterladen</Button>;
        }
      } else {
        // Ast darf hier nach Popup in die Liste der Anlagen wechseln
        if (!istLehrauftrag && !istVortrag) {
          pdfContent = antrag.a_eingangsdat ? <Button variant='outline-primary' onClick={this.onAntragDrucken}> {istTarif ? "Anlagen zum " : ""}{modus.labelVertrag} ausdrucken</Button> : null;
        }
      }
    }

    // Abrechnungsformular für Vortrag/Kolloquium: nur der Antragsteller, erst nachdem die Maßnahme abgelaufen ist
    const m_gueltigbis = _.get(antrag, "massnahmen[0].m_gueltigbis");
    if (istAst && istVortrag && antrag.a_asid == ANTRAGSTATUS.STATUS_VORTRAG_ABGESCHLOSSEN && m_gueltigbis && moment().isAfter(moment(m_gueltigbis), "day")) {
      pdfContent3 = <Button variant='outline-primary' onClick={this.onAbrechnungVortrag}>Abrechnungsformular-PDF herunterladen</Button>;
    }

    const mySchema = _.cloneDeep(schema);
    if (istLehrauftrag) {
      patchFields(mySchema, [{ field: "a_artid", display: "Maßnahmeart" }]);
    }

    const showBewilligungsvorbehaltHinweis = _.get(antrag, "massnahmen[0].m_bvorbehalt") === true;

    const headerContent = <>
      <h4>
        Antragsdaten
        {showBewilligungsvorbehaltHinweis && <span style={{ display: "inline-block", marginLeft: "0.75rem", fontSize: "0.8rem", color: "#b02a37", verticalAlign: "top", maxWidth: "75%" }}>HINWEIS: Bitte beachten Sie, dass der Antrag unter Vorbehalt steht und der Arbeitsvertrag erst abgeschlossen werden kann, wenn das Projekt im Finanzsystem der Bergischen Universität Wuppertal eingerichtet ist.</span>}
      </h4>
      <div className='float-right'>
        <div key='actions' className='actions'>{pdfContent}</div>
        <div key='actions2' className='actions'>{pdfContent2}</div>
        <div key='actions3' className='actions'>{pdfContent3}</div>
      </div>

    </>;

    const handleToggleTätigkeit = id => {
      const { expandTätigkeiten } = this.state;
      expandTätigkeiten[id] = !expandTätigkeiten[id];
      this.setState({ expandTätigkeiten });
    };

    const getKostenaufteilung = id => {
      switch (id) {
        case 1: return "Reservuerzbg erfolgt im Juli";
        case 2: return "Reservierung wird aufgeteilt";
        case 3: return "Reservierung erfolgt im Dezember";
        case 4: return "Reservierung erfolgt im Februar";
        default: return "(Angabe ungültig)";
      }
    };

    return <div className='box-panel'><Panel header={headerContent}>
      {wait && <Spinner />}
      {!wait && <span>


        <div>
          {istAst && antrag.a_asid == ANTRAGSTATUS.STATUS_UEBERARBEITEN
            ? (
              <span>Wenn Sie den Antrag erneut einreichen, werden die aktualisierten persönlichen Angaben zu Person, Werdegang etc. automatisch zum Antrag hinzugefügt und eingereicht</span>
            )
            : (
            <EditPanel
              editable={antragBearbeitbar(user, antrag)}
              header='Stammdaten'
              action='Speichern'
              schema={mySchema}
              injects={_.assign(selectInjects(this.props))} // getEntity für Schema-Funktionen injecten
              entity={antrag}
              onClose={this.onCloseAntrag}
              onChange={this.onChangeAntrag}
              onSave={this.saveAntrag}
            />

          )}
          {popupAntragDrucken && <AntragDruckenPopup onConfirm={this.confirmAntragDrucken} onCancel={this.closeAntragDrucken} />}
        </div>
        <br />

        {_.map(antrag.massnahmen, (m, i) => {
          return (
            <div key={i} className='box-panel'>
              <Panel header={[
                <span key='1'>Maßnahme PBP-{m.m_pbpid ? m.m_pbpid : ""}</span>,
                antragtypBeginnVerschiebbar(antrag, user) && antrag.a_asid != ANTRAGSTATUS.STATUS_UEBERARBEITEN && <div className='actions' key='2'>
                  <Link to={`/massnahme/${ m.m_id }`}><Button variant='outline-primary'>{istLehrauftrag ? "Zur Maßnahme wechseln" : "Bearbeiten"}</Button></Link>
                </div>,
              ]}>
                <Container fluid className='antrag-detail-table' style={{ position: "relative" }}>
                  <Row><Col xs={12} lg={4}>PBP-ID</Col><Col xs={12} lg={8}>PBP-{m.m_pbpid}</Col></Row>
                  {m.m_bez && <Row><Col xs={12} lg={4}>Bezeichnung:</Col><Col xs={12} lg={8}> {[m.m_bez]} </Col></Row>}
                  <Row><Col xs={12} lg={4}>Einrichtung:</Col><Col xs={12} lg={8}> {k_einrichtungLookup ? k_einrichtungLookup[m.m_eid].e_bez : ""} </Col></Row>
                  {istLehrauftrag && <Row><Col xs={12} lg={4}>Lehreinheit:</Col><Col xs={12} lg={8}> {m.ml_lehreinheit} </Col></Row>}
                  <Row><Col xs={12} lg={4}>Einrichtungsverantwortlich:</Col><Col xs={12} lg={8}> {m.m_e_asp} </Col></Row>
                  <Row><Col xs={12} lg={4}>Zeitraum:</Col><Col xs={12} lg={8}> {dateRange(m.m_gueltigab, m.m_gueltigbis)}
                    {m.m_gueltigbis && m.m_endefix != undefined && m.m_endefix == true ? " (Ende fix)" : " (Laufzeit fix)"}
                  </Col></Row>

                  {(istPR || istSachb || istGSB) && renderKurzfristinfo(m, "M", k_vertragsgrundLookup, true)}
                  {(istPR || istSachb || istGSB) && renderKurzfristinfo(m, "S", k_vertragsgrundLookup, true)}

                  <Row><Col xs={12} lg={4}>{TR("Ansprechpartner")}:</Col><Col xs={12} lg={8}> {[m.m_asp]} </Col></Row>

                  {!istVortrag && togglePlugin("arbeitszeit", args) && <Row><Col xs={12} lg={4}>Beschäftigungsumfang:</Col><Col xs={12} lg={8}>{_.map(m.massnahmepaz, (az, i) => <p key={i}>{dateRange(az.mp_gueltigab, az.mp_gueltigbis) + ` ${ istTarif ? az.mp_prozent + "%" : az.mp_std + " Wochenstunden" }`} </p>)}</Col></Row>}

                  {istVortrag && _.map(m.massnahmevortrag, (mnv, i) => <Fragment key={i}>
                    <Row><Col xs={12} lg={4}>Bezeichnung des Vortrags/Kolloquiums:</Col><Col xs={12} lg={8}>{mnv.mnv_bez}</Col></Row>
                    <Row><Col xs={12} lg={4}>Beschreibung:</Col><Col xs={12} lg={8} style={{ whiteSpace: "pre-wrap" }}>{mnv.mnv_beschreibung}</Col></Row>
                    <Row><Col xs={12} lg={4}>Pauschales Honorar in EUR:</Col><Col xs={12} lg={8}>{formatNumber(mnv.mnv_honorar, LocaleMoneyFormat)}</Col></Row>
                    {!_.isEmpty(mnv.dokumente) && <Row><Col xs={12}>
                      <Table striped>
                        <thead><tr><th>Vortragsflyer</th><th className='td-aktionen'>Aktionen</th></tr></thead>
                        <tbody>
                          {_.map(mnv.dokumente, (dok, di) => <DokumentWidget
                            key={di}
                            name={<span style={{ fontWeight: "normal" }}>{dok.dok_dateiname}</span>}
                            filename={dok.dok_dateiname}
                            urldownload={dok.url_download}
                            readonly
                          />)}
                        </tbody>
                      </Table>
                    </Col></Row>}
                  </Fragment>)}

                  {istTarif && <>
                    <Row>
                      <Col xs={12} lg={4}>Befristungsgrund:</Col>
                      <Col xs={12} lg={8}>
                        {k_tarifbefristetLookup[m.m_tbeid]?.tbe_bez}
                      </Col>
                    </Row>
                    {(m.m_zeitraumok === true || m.m_zeitraumok === false) &&
                    <Row>
                      <Col xs={12} lg={4}>Zeitraum OK:</Col>
                      <Col xs={12} lg={8}>
                        {m.m_zeitraumok ? "Ja" : "Nein"}
                      </Col>
                    </Row>
                    }
                    {m.m_phthema &&
                    <Row>
                      <Col xs={12} lg={4}>Thema Promotion/Habilitation:</Col>
                      <Col xs={12} lg={8}>
                        {m.m_phthema}
                      </Col>
                    </Row>
                    }
                    {m.m_phbetreuer &&
                    <Row>
                      <Col xs={12} lg={4}>Betreuer*in:</Col>
                      <Col xs={12} lg={8}>
                        {m.m_phbetreuer}
                      </Col>
                    </Row>
                    }
                    {m.m_phstand &&
                    <Row>
                      <Col xs={12} lg={4}>Beschreibung Stand:</Col>
                      <Col xs={12} lg={8}>
                        {m.m_phstand}
                      </Col>
                    </Row>
                    }
                    {m.m_phaufgaben &&
                    <Row>
                      <Col xs={12} lg={4}>Offene Aufgaben:</Col>
                      <Col xs={12} lg={8}>
                        {m.m_phaufgaben}
                      </Col>
                    </Row>
                    }
                    {m.m_phabschluss &&
                    <Row>
                      <Col xs={12} lg={4}>Prognose des Abschlusses:</Col>
                      <Col xs={12} lg={8}>
                        {formatDate(m.m_phabschluss, LocaleDateFormat)}
                      </Col>
                    </Row>
                    }
                    {istPR && m.m_tbeid && <Row><Col xs={24} lg={12}>
                      <Well>Rechtsgrundlage für die Befristung ist {istPRTuv
                        ? k_tarifbefristetLookup[m.m_tbeid]?.tbe_paragraph_prtuv
                        : istPRWiss
? k_tarifbefristetLookup[m.m_tbeid]?.tbe_paragraph_prwiss
                          : "unbekannt"}.</Well>
                    </Col></Row>}
                  </>}

                  {!istAst && <Row><Col xs={12} lg={4}>Finanzierungsbausteine:</Col><Col xs={12} lg={8}>
                    {_.map(m.massnahmefinanz, function(f, i) {
                      return <p key={i}>{dateRange(f.mfi_gueltigab, f.mfi_gueltigbis) + " " + formatKonto({ kostenstelle: f.mfi_kostenstelle, budgetkonto: f.mfi_budgetkonto }) + " " + (f.mfi_prozent < 100 ? f.mfi_prozent + "%" : "")}</p>;
                    })}</Col></Row>}

                  {!istAst && istLehrauftrag && m.ml_kostenaufteilung && m.ml_kostenaufteilung != 1 && <Row><Col xs={12} lg={4}>Kostenaufteilung (nur Wintersemester):</Col><Col xs={12} lg={8}>
                    {getKostenaufteilung(m.ml_kostenaufteilung)}
                  </Col></Row>}


                  {!istVortrag && togglePlugin("tätigkeit", args) && <>
                    <Row>
                      <Col xs={12} lg={4}>Tätigkeitsfelder:</Col>
                      <Col xs={12} lg={8}><ul>{_.map(
                        m.massnahmetaetigkeit,
                        (mt, mtIndex) => {
                          const arr = _.map(mt.mt_taetigkeiten, (t, i) => {
                            const bez = k_taetigkeitLookup[t]?.tat_bez;
                            const needMore = bez.length > MAX_TAET_BEZ || bez.includes("\n");
                            return <li style={{ whiteSpace: "pre-wrap" }} key={`taet-${ mtIndex }-${ i }`}>{expandTätigkeiten[t] ? bez : ellipsis(bez, MAX_TAET_BEZ, " ...", true)} {needMore && <a onClick={() => handleToggleTätigkeit(t)}><Pill variant='success'>{expandTätigkeiten[t] ? "Weniger anzeigen" : "Mehr anzeigen"}{"\u00a0"}{"\u00a0"}<Awesome name={expandTätigkeiten[t] ? "arrow-up" : "arrow-down"} /></Pill></a>} <br /></li>;
                          });
                          if (mt.mt_text) {
                            arr.push(<li key={`mt-text-${ mtIndex }`}>{mt.mt_text}</li>);
                          }
                          return arr;
                        },
                      )
                      }</ul></Col>
                    </Row>
                    {(istPR || istSachb || istGSB) && antrag.a_artid == VERTRAGSARTEN.WHF
? <Row><Col xs={12} lg={4} />
  <Col xs={12} lg={8}><Well>{TR("Rechtsgrundlage_WHF")}</Well></Col></Row>
                      : antrag.a_artid == VERTRAGSARTEN.SHK ? <Row><Col xs={12} lg={4} /><Col xs={12} lg={8}><Well>{TR("Rechtsgrundlage_SHK")}</Well></Col></Row> : null}
                  </>}

                  {(m.m_artid == VERTRAGSARTEN.WHK || (istTarif && antrag.atd_ist_wiss)) &&
                    <>
                      {((istPR || istSachb || istGSB) && !istTarif) ? <Row><Col xs={12} lg={4} /><Col xs={12} lg={8}><Well>{TR("Rechtsgrundlage_WHK")}</Well></Col></Row> : null}
                      <Row><Col xs={12} lg={4}>Qualifikationsziele:</Col><Col xs={12} lg={8}><ul>{_.map(
                        m.massnahmequaliziel,
                        (mq, mqIndex) => {
                          const arr = _.map(mq.mq_qualiziele, (t, tIndex) => <li key={`qz-${ mqIndex }-${ tIndex }`}>{k_qualizielLookup[t].qz_bez} <br /></li>);
                          if (mq.mq_text) {
                            arr.push(<li key={`qz-text-${ mqIndex }`}>{mq.mq_text}</li>);
                          }
                          return arr;
                        },
                      )
                      }</ul></Col></Row>
                    </>}
                  {antrag.a_artid == VERTRAGSARTEN.SHK && m.m_staveroeffentlicht && <Row><Col xs={12} lg={4}>Stellenausschreibung:</Col><Col xs={12} lg={8}> {dateRange(m.m_stavon, m.m_stabis)} ( {m.m_staort ? m.m_staort.join(", ") : "Keine Angabe zum Ort der Veröffentlichung"} ) </Col></Row>}

                  {!istAst && istTarif && m.massnahmetarif?.length > 0 &&
                    <Row>
                      <Col xs={12} lg={4}>Stellenausschreibung:</Col>
                      <Col xs={12} lg={8}>
                        <Row>
                          <Col xs={6}>Ausschreibungskennz.:</Col>
                          <Col xs={6}>{m.massnahmetarif[0].mtf_auskennz}</Col>
                        </Row>
                        <Row>
                          <Col xs={6}>Ausschreibungsverzicht:</Col>
                          <Col xs={6}><Pill variant={m.massnahmetarif[0].mtf_ohneaus ? "success" : "default"}>{m.massnahmetarif[0].mtf_ohneaus ? "Ja" : "Nein"}</Pill></Col>
                        </Row>
                        {m.massnahmetarif[0].mtf_ohneaus && m.massnahmetarif[0].mtf_ist_wiss
                          && !_.isEmpty(m.massnahmetarif[0].mtf_ohneausgrund_kogid) && <Row>
                          <Col xs={6}>Gründe für den Verzicht:</Col>
                          <Col xs={6}>
                            {k_ohneaus_grundLookup && <ul className='ui-no-margin'>
                              {_.map(m.massnahmetarif[0].mtf_ohneausgrund_kogid, (id, index) => <li key={`grund-${ index }`}>{k_ohneaus_grundLookup[id]?.kog_kbez}</li>)}
                            </ul>}
                          </Col>
                        </Row>}
                        {m.massnahmetarif[0].mtf_ohneaus && m.massnahmetarif[0].mtf_ohneausgrund && <Row>
                          <Col xs={6}>Erläuterung zum Verzicht:</Col>
                          <Col xs={6}>{m.massnahmetarif[0].mtf_ohneausgrund}</Col>
                        </Row>}
                        {!m.massnahmetarif[0].mtf_ohneaus && <Row>
                          <Col xs={6}>Anzahl Bewerber (männlich):</Col>
                          <Col xs={6}>{m.massnahmetarif[0].mtf_bewerber_m}</Col>
                        </Row>}
                        {!m.massnahmetarif[0].mtf_ohneaus && <Row>
                          <Col xs={6}>Anzahl Bewerber (weiblich):</Col>
                          <Col xs={6}>{m.massnahmetarif[0].mtf_bewerber_w}</Col>
                        </Row>}
                        {!m.massnahmetarif[0].mtf_ohneaus && <Row>
                          <Col xs={6}>Anzahl Bewerber (divers):</Col>
                          <Col xs={6}>{m.massnahmetarif[0].mtf_bewerber_d}</Col>
                        </Row>}
                      </Col>
                    </Row>}

                  {istTarif && m.massnahmetarif?.length > 0 &&
                    <Row>
                      <Col xs={12} lg={4}>Aufgabenbeschreibung:</Col>
                      <Col xs={12} lg={8}>
                        <Row>
                          <Col xs={6}>Einsatz als:</Col>
                          <Col xs={6}>{m.massnahmetarif[0].mtf_einsatz_als}</Col>
                        </Row>
                        <Row>
                          <Col xs={6}>Beschreibung:</Col>
                          <Col xs={6}>{m.massnahmetarif[0].mtf_aufgabenbeschreibung}</Col>
                        </Row>
                      </Col>
                    </Row>}

                  {istLehrauftrag && <>
                    <Row><Col style={{ textAlign: "left" }} colSpan={2}><h4>Details zum Lehrauftrag</h4></Col><Col xs={12} lg={8} /></Row>
                    <Row><Col xs={12} lg={4}>Bezeichnung:</Col><Col xs={12} lg={8}>{m.ml_bezeichnung}</Col></Row>
                    <Row><Col xs={12} lg={4}>Künstlerisch/Publizistisch:</Col><Col xs={12} lg={8}>{
                      <Pill variant={m.ml_istkuenstlerisch ? "success" : "default"}>
                        {m.ml_istkuenstlerisch ? "Ja" : "Nein"}
                      </Pill>
                    }</Col></Row>
                    <Row><Col xs={12} lg={4}>Veranstaltungstyp:</Col><Col xs={12} lg={8}>{m.ml_veranstaltungsart}</Col></Row>
                    <Row><Col xs={12} lg={4}>Veranstaltungsart:</Col><Col xs={12} lg={8}>{m.ml_veranstaltungstyp}</Col></Row>
                    <Row><Col xs={12} lg={4}>Wochentage:</Col><Col xs={12} lg={8}>{formatWochentage(m.ml_wochentage)}</Col></Row>
                    <Row><Col xs={12} lg={4}>Begründung:</Col><Col xs={12} lg={8}>{m.ml_begruendung}</Col></Row>
                    <Row><Col xs={12} lg={4}>Vergütung:</Col><Col xs={12} lg={8}>{m.ml_lehrauftragsart}</Col></Row>
                    <Row><Col xs={12} lg={4}>Ausführliche Begründung:</Col><Col xs={12} lg={8}>{m.ml_klebegruendung}</Col></Row>
                    <Row><Col xs={12} lg={4}>Stundensatz in EUR:</Col><Col xs={12} lg={8}>{formatNumber(m.ml_stundensatz, LocaleMoneyFormat)}</Col></Row>
                    <Row><Col xs={12} lg={4}>Fahrtkosten in EUR:</Col><Col xs={12} lg={8}>{formatNumber(m.ml_fahrtkosten, LocaleMoneyFormat)}</Col></Row>
                    <Row><Col xs={12} lg={4}>Gesamt-Stunden:</Col><Col xs={12} lg={8}>{m.ml_gesamtstd}</Col></Row>
                    <Row><Col xs={12} lg={4}>Gesamtsumme in EUR:</Col><Col xs={12} lg={8}>{formatNumber(m.ml_gesamtstd * m.ml_stundensatz + m.ml_fahrtkosten, LocaleMoneyFormat)}</Col></Row>
                    <Row><Col xs={12} lg={4}>Durchschnittliche LVS:</Col><Col xs={12} lg={8}>{formatNumber(m.ml_sws)}</Col></Row>
                  </>}

                  {(istPR || istSachb || istDekan) && <FinanzierungQVBHinweis massnahme={m} />}
                  {istTarif && m.massnahmedeputat?.length > 0 &&
                    <Row>
                      <Col xs={12} lg={4}>Deputat:</Col>
                      <Col xs={12} lg={8}>
                        {m.massnahmedeputat.map((dep, i) => (<Fragment key={`dep-fragment-${ i }`}>
                          <Row className='deputat-row' key={"dep-" + i}>
                            <Col xs={12}>
                              {`${ dep.md_sws } LVS ${ dep.md_lehreinheit } (${ dateRange(dep.md_gueltigab, dep.md_gueltigbis) }, ${ k_amtsdienstbezLookup[dep.md_adbid]?.adb_bez || "" })`}
                            </Col>
                          </Row>
                          {dep.md_mind_dmiid && <Row className='deputat-row deputat-mind-row' key={"mind-" + i}>
                            <Col xs={12}>
                              {`Minderung: ${ dep.md_mind_sws } LVS (${ dateRange(dep.md_gueltigab, dep.md_gueltigbis) }, Grund: ${ k_deputatminderungLookup[dep.md_mind_dmiid]?.dmi_bez || "" })`}
                            </Col>
                          </Row>}
                        </Fragment>
                        ))}
                      </Col>
                    </Row>}
                  {istSachb && m.m_kommentarpersonalabteilung?.trim().length > 0 &&
                    <Row>
                      <Col xs={12} lg={4}>Kommentar für Personalabteilung:</Col>
                      <Col xs={12} lg={8}>{m.m_kommentarpersonalabteilung}</Col>
                    </Row>}
                </Container>
              </Panel>
            </div>);
        })}
      </span>}
    </Panel></div>;
  }

  onAntragformular = () => {
    const { currentAntrag, user } = this.props;
    if (VERTRAGSARTEN_LEHRAUFTRAG.includes(currentAntrag.a_artid)) {
      window.open(`/api/shkpdf/fillform/lehrauftrag/ANTRAG-LEHRAUFTRAG/${ currentAntrag.a_id }?token=${ user.token }`);
    } else if (VERTRAGSARTEN_TARIF.includes(currentAntrag.a_artid)) {
      window.open(`/api/shkpdf/fillform/tarif/ANTRAG-TARIF/${ currentAntrag.a_id }?token=${ user.token }`);
    } else if (VERTRAGSARTEN_VORTRAG.includes(currentAntrag.a_artid)) {
      window.open(`/api/shkpdf/fillform/vortrag/${ currentAntrag.a_id }?token=${ user.token }`);
    } else {
      window.open(`/api/shkpdf/fillform/ANTRAG/${ currentAntrag.a_id }?token=${ user.token }`);
    }
  };

  onAbrechnungVortrag = () => {
    const { currentAntrag, user } = this.props;
    window.open(`/api/shkpdf/fillform/vortrag/ABRECHNUNG-VORTRAG/${ currentAntrag.a_id }?token=${ user.token }`);
  };

  onAntragDrucken = () => {
    this.setState({ popupAntragDrucken: true });
  };
  closeAntragDrucken = () => {
    this.setState({ popupAntragDrucken: false });
  };
  confirmAntragDrucken = () => {
    this.closeAntragDrucken();
    const { history, location } = this.props;
    this.setState({ errorMessage: null });
    history.push(popAndReplaceComponent(location, 3, "anlagen"));
  };

  onEmpfangsbescheinigung = () => {
    const { currentAntrag, user } = this.props;
    window.open(`/api/shkpdf/fillform/EMPFANGSBESCHEINIGUNG/${ currentAntrag.a_id }?token=${ user.token }`);
  };
  onBeauftragung = () => {
    const { currentAntrag, user } = this.props;
    window.open(`/api/shkpdf/fillform/lehrauftrag/BEAUFTRAGUNG-LEHRAUFTRAG/${ currentAntrag.a_id }?token=${ user.token }`);
  };
}
